export default __webpack_public_path__ + "static/media/facebook.ab121e9c.svg";